import $ from 'jquery';
import debug from "debug";

// See polyfills bundle - this should not be needed here too
// import "./polyfills";
import "./plugins";
import "./components";
import "./vendor";

const log = debug('fusion-core');

$(()=>{
	log('ready');
});



// WEBPACK FOOTER //
// ./project/client/src/core/index.js